import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import Moment from "react-moment";
import ConfirmedAppointmentBox from "./ConfirmedAppointmentBox";
const AppDayTable = ({ AppDay }) => {
  let navigate = useNavigate();
  const MakeHeaderRow = () => {
    var headerArr = [];
    for (let i = 0; i < 24; i++) {
      headerArr.push(<th>{i < 10 ? "0" + i + ":00" : i + ":00"}</th>);
    }

    return headerArr;
  };

  const GoToAccSessionDetails = (AccSession) => {
    navigate("/AccountingSessions/Details", {
      state: {
        SearchSession: AccSession,
      },
    });
  };

  const GoToDetails = (appHour) => {
    navigate("/Appointments/AppHourDetails", {
      state: {
        AppHour: appHour,
      },
    });
  };
  const getConfirmedAppointments = (AppHour) => {
    if (AppHour.getConfirmedAppointment) {
      return <ConfirmedAppointmentBox Appointment={AppHour.getConfirmedAppointment} />;
    }
    if (AppHour.getFirstConfirmedAppointment && !AppHour.getSecondConfirmedAppointment) {
      console.log("has confirmed appointment", AppHour);
      return (
        <>
          <ConfirmedAppointmentBox Appointment={AppHour.getFirstConfirmedAppointment} />

          <span class="badge badge-danger">NO CONFIRMED SECOND APPOINTMENTS</span>
        </>
      );
    }
    if (!AppHour.getFirstConfirmedAppointment && AppHour.getSecondConfirmedAppointment) {
      return (
        <>
          <span class="badge badge-danger">NO CONFIRMED FIRST APPOINTMENT</span>

          <ConfirmedAppointmentBox Appointment={AppHour.getSecondConfirmedAppointment} />
        </>
      );
    }
    if (AppHour.getFirstConfirmedAppointment && AppHour.getSecondConfirmedAppointment) {
      return (
        <>
          <span class="badge badge-primary">1st</span>

          <ConfirmedAppointmentBox Appointment={AppHour.getFirstConfirmedAppointment} />
          <span class="badge badge-secondary">2nd</span>

          <ConfirmedAppointmentBox Appointment={AppHour.getSecondConfirmedAppointment} />
        </>
      );
    }
  };

  const ToggleSessionAdmission = async (AccSession) => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = AccSession.id;

    let res = await SessionsApi.ToggleAccountingSessionAdmission(req);

    if (res.status == "Success") {
      Swal.fire("Success", res.message, "success");

      window.location.reload();
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const MakeAppHourCell = (appHour) => {
    return (
      <td>
        <div className="card">
          <MDTypography className="custom-card">
            <span>Id:</span> <p>{appHour.id}</p>
          </MDTypography>

          <MDTypography className="custom-card">
            <span>Time:</span>
            {/* <Moment className="custom-font" format="YYYY/MM/DD HH/MM">
              <p > {appHour.appointmentHourTime}</p>
            </Moment> */}
            {appHour.appointmentHourTime.split("T")[1]}
          </MDTypography>

          {appHour.hasConfirmedAppointment ? (
            getConfirmedAppointments(appHour)
          ) : (
            <MDTypography className="custom-card">
              <span class="badge badge-danger">NO CONFIRMED APPOINTMENTS</span>
            </MDTypography>
          )}

          <MDTypography className="custom-card">
            <span>Appointment List :</span> <p>{appHour.getAppointments.length}</p>
          </MDTypography>

          <button onClick={() => GoToDetails(appHour)} className="btn btn-dark">
            Options
          </button>
        </div>
      </td>
    );
  };

  const MakeTableRow = (tDay) => {
    return (
      <tr>
        <td>{tDay.getTherapist.getUser.name}</td>
        {tDay.getAppointmentHours
          .sort((a, b) => (a.hour > b.hour ? 1 : b.hour > a.hour ? -1 : 0))
          .map((appHour) => {
            return MakeAppHourCell(appHour);
          })}
      </tr>
    );
  };

  return (
    <div className="card app-day">
      <MDTypography variant="h2">
        <span>Day:</span> <p>{AppDay.dateDay.split("T")[0]}</p>
      </MDTypography>
      <table className="table table-bordered mt-4 mx-4">
        <thead>
          <tr className="small-width text-center">
            <th className="small-width custom-font">Name / Time</th>
            {MakeHeaderRow().map((r) => {
              return r;
            })}
          </tr>
        </thead>
        <tbody className="small-width text-center font-weight-bold ">
          {AppDay.getTherapists.map((tDay) => {
            return MakeTableRow(tDay);
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AppDayTable;
